import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppService, DentalReferralFormReviewNote } from '../../app.service';
import { AlertService } from '../../common/alert.service';
import { LoadingService } from '../../common/loading.service';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider'; 

@Component({
  selector: 'app-notes-container',
  templateUrl: './notes-container.component.html',
  styleUrls: ['./notes-container.component.scss']
})
export class NotesContainerComponent implements OnInit {

  @Input()
  public reviewId: number;

  @Input()
  public readOnly: boolean = false;

  @Output()
  OnLoadNotes = new EventEmitter();

  @Output()
  OnNewNoteSave = new EventEmitter<DentalReferralFormReviewNote>();

  @Output()
  OnNoteSave = new EventEmitter<DentalReferralFormReviewNote>();

  @Output()
  OnNoteDelete = new EventEmitter<DentalReferralFormReviewNote>();

  public notes: DentalReferralFormReviewNote[] = [];

  public form: FormGroup;
  public newNoteFormControl: FormControl;

  public showNewNote: boolean = false;
  public shrinkNotes: boolean = true;
  public sortBy: string = 'created';


  constructor(
    private service: AppService,
    private alert: AlertService,
    private spinner: LoadingService,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.form = new FormGroup({});

    this.newNoteFormControl = new FormControl();
    this.form.addControl('newNoteFormControl', this.newNoteFormControl);
  }

  public loadNotes() {
    this.OnLoadNotes.emit();
    
  }

  public saveNewNote() {
    const newNote = new DentalReferralFormReviewNote();
    newNote.note = this.newNoteFormControl.value;
    newNote.reviewId = this.reviewId;

    this.OnNewNoteSave.emit(newNote);
  }

  public saveNote(note: DentalReferralFormReviewNote) {
    if (note) {
      this.OnNoteSave.emit(note);
    }
  }

  public deleteNote(note: DentalReferralFormReviewNote) {
    if (note) {
      this.OnNoteDelete.emit(note);
    }
  }


  public resetNotes() {
    this.reviewId = null;
    this.notes = [];
    this.readOnly = false;
  }

  public clearNewNote() {
    this.newNoteFormControl.reset();
    this.showNewNote = false;
  }

  public sortNotes($event: any) {
    if (this.notes) {

      this.sortBy = $event.target.value;

      switch (this.sortBy) {
        case 'modified': {
          this.notes = this.notes.sort((objA, objB) => {
            const dateB = new Date(objB.modifiedDate);
            const dateA = new Date(objA.modifiedDate);

            console.log(dateB);
            console.log(dateA);

            return dateB.getTime() - dateA.getTime();
          });
          break;
        }
        case 'created': {
          this.notes = this.notes.sort((objA, objB) => {
            const dateB = new Date(objB.createdDate);
            const dateA = new Date(objA.createdDate);

            console.log(dateB);
            console.log(dateA);

            return dateB.getTime() - dateA.getTime();
          });
          break;
        }
        case 'modifiedUser': {
          this.notes = this.notes.sort((objA, ObjB) => {
            if (objA.modifiedByUser.fullName > ObjB.modifiedByUser.fullName) {
              return 1;
            }
            if (objA.modifiedByUser.fullName < ObjB.modifiedByUser.fullName) {
              return -1
            }
            return 0;
          });
          break;
        }
        case 'createdUser': {
          this.notes = this.notes.sort((objA, ObjB) => {
            if (objA.createdByUser.fullName > ObjB.createdByUser.fullName) {
              return 1;
            }
            if (objA.createdByUser.fullName < ObjB.createdByUser.fullName) {
              return -1
            }
            return 0;
          });
          break;
        }
        default: {
          //statements; 
          break;
        }
      }
    }
  }

}
